import { createAction } from "@reduxjs/toolkit";

enum LayoutReducer {
	setPageTitle = "[LAYOUT] Set Page Title",
}

export const layoutSetPageTitle = createAction<string>(
	LayoutReducer.setPageTitle
);
